import { Frown } from "lucide-react";
import { motion } from "motion/react";

import settings from "../../settings";

const ErrorPage = ({
  sentryEventId,
  is404error,
}: {
  sentryEventId?: null | number | string;
  is404error: boolean;
}) => {
  const mailToLink =
    sentryEventId &&
    `mailto:kundservice@krea.se?subject=Lender web error (Error eventId: ${sentryEventId})&body=Please describe what went wrong here.`;

  return (
    <motion.div
      className="error-page flex h-full w-full items-center justify-center"
      initial="initial"
      animate="animate"
      exit="exit"
      variants={settings.loginAnimation.variants}
      transition={settings.routeAnimation.pageTransition}
    >
      <div className="flex flex-col items-center">
        <div className="mb-5 text-gray-600">
          <Frown className="size-8" />
        </div>
        <div className="text-page-title">Oops! {is404error && "404"}</div>
        <div className="mb-5 text-section">Something went wrong</div>
        <div className="text-lg">
          Please <a href="/">reload page</a>
          {mailToLink ? (
            <span> or {<a href={mailToLink}>contact us!</a>}</span>
          ) : null}
        </div>
      </div>
    </motion.div>
  );
};

export default ErrorPage;
